import { configureStore } from '@reduxjs/toolkit';
import { rateSlice } from '@store/slices/Rate.slice';

import { accessorialChargesSlice } from '@features/AccessorialCharges/accessorialCharges.slice';

export const store = configureStore({
  reducer: {
    rate: rateSlice.reducer,
    accessorialCharges: accessorialChargesSlice.reducer,
  },
  devTools: import.meta.env.MODE === 'development',
});

export type RootState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch;
